// extracted by mini-css-extract-plugin
module.exports = {"page-header-actions-training":"Training_page-header-actions-training__16t_E","search":"Training_search__9DPXJ","page-header-right":"Training_page-header-right__1PjOr"};